document.addEventListener('alpine:init', function () {
    Alpine.data('ctaModule', function () {
        return {
            init: function () {
                var image = this.$refs.ctaImage;
                if (!image)
                    return;
                // Respect prefers-reduced-motion.
                if (window.matchMedia('(prefers-reduced-motion: reduce)').matches)
                    return;
                // TODO: Reinstate when landscape image provided
                // window.gsap.fromTo(
                //   image,
                //   { scale: 1.2 },
                //   {
                //     scale: 1,
                //     ease: 'none',
                //     scrollTrigger: {
                //       trigger: image,
                //       start: 'middle bottom',
                //       end: 'bottom bottom',
                //       scrub: true,
                //     },
                //   },
                // );
            },
        };
    });
});
